function itemHtml(ctx, it) {
    return `<article class="fq-exchange"${ctx.reveal(it.idx)}><div class="fq-question"><span class="fq-label">${ctx.t('youAsk')}</span><h3 class="fq-q">${it.q}</h3></div><div class="fq-reply"><span class="fq-label">${ctx.t('weAnswer')}</span><div class="fq-a">${it.aHtml}</div></div></article>`;
}
const dialogue = {
    id: 'dialogue',
    name: 'Dialogue',
    tag: 'Interview-style Q&A',
    styleTag: 'Conversational',
    description: 'Questions and answers sit across from each other like a conversation. Soft answer panels and small speaker labels bring a personal voice to your FAQ.',
    layout: 'chat',
    defaultAccent: '#a34579',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        return {
            html: `<div class="fq-wrap"><h2 class="fq-title">${ctx.title}</h2>${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}<div class="fq-list">${ctx.items.map((it) => itemHtml(ctx, it)).join('')}</div></div>`,
            css: `
.FQM .fq-wrap{max-width:900px;margin:0 auto;overflow-wrap:anywhere}
.FQM .fq-title{margin:0 0 10px;font-family:${ctx.v.head};font-size:36px;font-weight:650;line-height:1.15;letter-spacing:-.02em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:15.5px;line-height:1.65;color:${ctx.v.sub}}
.FQM .fq-list{margin-top:30px}
.FQM .fq-exchange{display:flex;flex-wrap:wrap;align-items:flex-start;gap:16px 30px;padding:24px 0;border-top:1px solid ${ctx.v.border}}
.FQM .fq-question{flex:1 1 230px;min-width:0;padding:10px 0}
.FQM .fq-reply{flex:2 1 300px;min-width:0;padding:20px 24px;border-radius:0 ${ctx.v.radiusCard} ${ctx.v.radiusCard} ${ctx.v.radiusCard};background:${ctx.v.soft}}
.FQM .fq-label{display:block;margin-bottom:10px;font-family:${ctx.v.mono};font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.1em;color:${ctx.v.sub}}
.FQM .fq-q{margin:0;font-family:${ctx.v.head};font-size:21px;font-weight:600;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-a{font-size:15px;line-height:1.75;color:${ctx.v.ink}}
`,
        };
    },
};
export default dialogue;
